module.exports = __webpack_public_path__ + "img/stone_oak_list.b8bd8581.jpg";